import type { HttpClient } from '@remodeling/base';
import {
  GetFavoriteTestStartResponse,
  GetFavoriteTestStyleRequest,
  GetFavoriteTestStyleResponse,
  SendFavoriteTestRequest,
  SendFavoriteTestResponse,
} from '../../model';

export class GetFavoriteTestStartGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetFavoriteTestStartResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/favorite-test`,
    });
  }
}

export class SendFavoriteTestGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: SendFavoriteTestRequest) {
    return await this.httpClient.request<SendFavoriteTestResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/favorite-test/feedback`,
      body: req,
    });
  }
}

export class GetFavoriteTestStyleGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetFavoriteTestStyleRequest) {
    return await this.httpClient.request<GetFavoriteTestStyleResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/favorite-test/styles/${req.styleId}`,
    });
  }
}
